import React from "react";
import Link from "gatsby-link";
import ClassNames from "classnames";
import RenderHtml from "../../utils/render-html";
import Bus from "../../utils/bus";
let BUS = new Bus();

class IngredientsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    BUS.listen("OPEN_INGREDIENTMODAL", this.open);
  }

  componentWillUnmount() {
    BUS.stopListening("OPEN_INGREDIENTMODAL", this.open);
  }

  open(event) {
    console.log(event)
    this.setState({
      open: true,
      content: event.detail.content
    });
  }

  close() {
    this.setState({
      open: false
    });
  }

  render() {
    if (!this.state.open) {
      return null;
    }

    return (
      <div className="TextModal">
        <div className="bg" onClick={this.close} />
        <div className="content">
          <div
            className="TextContent"
            dangerouslySetInnerHTML={RenderHtml.go(this.state.content)}
          />
        </div>
        <button className="close" onClick={this.close}>
          <span>&times;</span>
        </button>
      </div>
    );
  }
}

export default IngredientsModal;



// WEBPACK FOOTER //
// ./src/components/ingredients/modal.js